'use strict';

import state from './state';
import {reverseUrl} from 'utils/django';


export default function(incident) {
	state(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
}
